/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

import { EuiLink, EuiSpacer, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { useBillingHistoryUrl } from '@modules/urls/billing'

interface Props {
  organizationId: string
}

const PurchaseOrderPaymentDetails = ({ organizationId }: Props) => {
  const navigate = useNavigate()
  const billingHistoryUrl = useBillingHistoryUrl(organizationId)

  return (
    <Fragment>
      <EuiText size='s' data-test-id='payment-details'>
        <FormattedMessage
          id='billing-overview.payment-details.purchase-order'
          defaultMessage='Paid by purchase order'
        />
      </EuiText>
      <EuiSpacer size='m' />

      <EuiLink onClick={() => navigate(billingHistoryUrl)}>
        <FormattedMessage
          id='billing-overview.payment-details.view-billing-history'
          defaultMessage='View billing history'
        />
      </EuiLink>

      <EuiSpacer size='l' />

      <FormattedMessage
        id='billing-overview.payments-details.contact-button'
        defaultMessage='<link>Contact us</link> for other forms of payment'
        values={{
          link: (content) => (
            <EuiLink
              external={false}
              href='https://www.elastic.co/contact?baymax=rtp&rogue=eswt-1165-a#sales'
              target='_blank'
            >
              {content}
            </EuiLink>
          ),
        }}
      />
    </Fragment>
  )
}

export default PurchaseOrderPaymentDetails
